import * as React from 'react';

const SvgPeople = (props) => (
  <svg
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    {...props}
  >
    <path
      d='M21.001 4.667c-6.113 0-11.083 4.97-11.083 11.083 0 5.997 4.69 10.85 10.803 11.06.187-.023.374-.023.514 0h.163c5.973-.21 10.663-5.063 10.687-11.06 0-6.113-4.97-11.083-11.084-11.083ZM32.854 33.017c-6.51-4.34-17.126-4.34-23.683 0C6.208 35 4.574 37.683 4.574 40.553c0 2.87 1.634 5.53 4.574 7.49 3.266 2.194 7.56 3.29 11.853 3.29s8.587-1.096 11.853-3.29c2.94-1.983 4.574-4.643 4.574-7.536-.024-2.87-1.634-5.53-4.574-7.49ZM46.642 17.127c.373 4.526-2.847 8.493-7.303 9.03h-.117c-.14 0-.28 0-.397.046-2.263.117-4.34-.606-5.903-1.936 2.403-2.147 3.78-5.367 3.5-8.867a10.83 10.83 0 0 0-1.797-5.087 8.34 8.34 0 0 1 2.964-.816c4.573-.397 8.656 3.01 9.053 7.63Z'
      fill='currentColor'
    />
    <path
      d='M51.311 38.71c-.187 2.263-1.633 4.223-4.06 5.553-2.333 1.284-5.273 1.89-8.19 1.82 1.68-1.516 2.66-3.406 2.847-5.413.233-2.893-1.144-5.67-3.897-7.887-1.563-1.236-3.383-2.216-5.367-2.94 5.157-1.493 11.644-.49 15.634 2.73 2.147 1.727 3.243 3.897 3.033 6.137Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgPeople;
